module.exports = __webpack_public_path__ + "Icon_quality_sincomentario.png";